import { useStore } from "../../../../../contexts";
import { useConnectBankAccount } from "../../../../../hooks/useConnectBankAccount";
import { selectors } from "../../../../../store/state-selectors";
import { isBankAccountConnected } from "../../../../../store/store.model";
import { ConnectBankAccountIcon } from "../../BusinessOnboardingWidget.icons";
import { StepLayout } from "../../BusinessOnboardingWidget.utils";
import styles from "./ConnectBankAccount.module.scss";
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
export default function ConnectBankAccount(props) {
  const {
    isComplete
  } = props;
  const {
    Description,
    ConnectButton,
    BankAccountDetails
  } = useConnectBankAccount();
  const payoutBankAccount = useStore(selectors.user.payoutBankAccount);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx(StepLayout, {
      id: "connectBankAccount",
      title: isComplete ? "You've successfully connected your bank account" : 'Link your bank account for payouts',
      subtitle: isComplete ? isBankAccountConnected(payoutBankAccount) && /*#__PURE__*/_jsx(BankAccountDetails, {
        payoutBankAccount: payoutBankAccount
      }) : /*#__PURE__*/_jsx(Description, {
        linkTestid: "onboarding-widget-connect-account-read-more"
      }),
      actions: /*#__PURE__*/_jsx(ConnectButton, {
        className: styles.actionsWrapper,
        testid: "onboarding-widget-connect-account-btn",
        enterManuallyTestid: "onboarding-widget-routing-number"
      }),
      icon: /*#__PURE__*/_jsx(ConnectBankAccountIcon, {})
    })
  });
}